import ReactDOM from 'react-dom';
import App from './App';
import fetchIntercept from 'fetch-intercept';
import KeycloakService from 'services/keycloak.service';

const renderApp = (keycloak: any) => ReactDOM.render(<App  keycloak={keycloak} />, document.getElementById('root'));
KeycloakService.initKeycloak(renderApp);

fetchIntercept.register({
    request: function (url, config) {
        config.headers['Authorization'] = `Bearer ${KeycloakService.getToken()}`;
        return [url, config];
    },
});
